const footerData = {
  trustPilotUrl:
    "https://api.trustpilot.com/v1/business-units/5808db060000ff0005964ce4/?apikey=mKkMk1ZCAPOWHFQIZpYzzE74A2XWlVjd",
  top: {
    contact: {
      contactTitle: "Let's talk:",
      phone1: "0161 300 7235",
    },
    links: {
      column1: {
        linksTitle: "For employers",
        link1: {
          label: "Overview",
          url: "https://www.hiring-hub.com/",
        },
        link2: {
          label: "Post a job",
          url: "https://www.hiring-hub.com/Post-a-job-V3/",
        },
        link3: {
          label: "Testimonials",
          url: "https://www.hiring-hub.com/testimonials-and-reviews/",
        },
        link4: {
          label: "Create an account",
          url: "https://app.hiring-hub.com/employer/register",
        },
      },
      column2: {
        linksTitle: "For recruiters",
        link1: {
          label: "Overview",
          url: "https://www.hiring-hub.com/recruitment-agencies/",
        },
        link2: {
          label: "Join Hiring Hub",
          url: "https://www.hiring-hub.com/create-free-profile/",
        },
        link3: {
          label: "Testimonials",
          url: "https://www.hiring-hub.com/testimonials-and-reviews/",
        },
      },
      column3: {
        linksTitle: "About us",
        link1: {
          label: "About",
          url: "https://www.hiring-hub.com/hiring-hub-uks-1-recruitment-marketplace/",
        },
        link2: {
          label: "Contact us",
          url: "https://www.hiring-hub.com/contact/",
        },
        link3: {
          label: "FAQs",
          url: "https://www.hiring-hub.com/faqs/",
        },
        link4: {
          label: "Terms of Business",
          url: "https://www.hiring-hub.com/termsofbusiness/",
        },
      },
      column4: {
        link1: {
          label: "Blog",
          url: "https://blog.hiring-hub.com/",
        },
        link2: {
          label: "Careers",
          url: "https://www.hiring-hub.com/careers/",
        },
      },
    },
  },
  middle: {
    social: {
      facebook: "https://en-gb.facebook.com/HiringHub/",
      twitter: "https://twitter.com/hiringhub?lang=en",
      linkedin: "https://www.linkedin.com/company/1849822/",
    },
    links: {
      link1: {
        label: "About",
        url: "https://www.hiring-hub.com/hiring-hub-uks-1-recruitment-marketplace/",
      },
      link2: {
        label: "Site map",
        url: "https://www.hiring-hub.com/sitemap/",
      },
      link3: {
        label: "Terms of Use",
        url: "https://www.hiring-hub.com/terms-of-use/",
      },
      link4: {
        label: "Privacy Policy",
        url: "https://www.hiring-hub.com/privacypolicy/",
      },
    },
  },
  bottom: {
    copy: "The Hiring Hub Ltd. All rights reserved",
    about:
      "Hiring Hub™ is an award-winning recruitment agency marketplace based in the UK. It connects companies to a trusted network of vetted, specialist recruitment agencies. Employers use it to quickly and conveniently broaden their candidate search and fill professional jobs, faster. Recruitment agencies partner with Hiring Hub to get access to qualified jobs from motivated employers and increase their fee income. Hiring Hub is free for employers to use. Recruitment agencies pay a monthly membership fee to access the marketplace. Average time-to-hire on Hiring Hub's marketplace from Jan 2018-Jan 2019 was 20 days, versus an industry average of 68 days according to a recent survey by CEB Global/Gartner. Hiring Hub is a Deloitte EMEA Fast 500 tech company, was included in GP Bullhound's Top 50 fastest growing tech companies in the North, and part of Silicon Valley Comes to the UK (SVC2UK) Scale-up Top 50 Club. To learn more about Hiring Hub and its recruitment agency marketplace, call: 0161 300 7235.",
  },
};

export { footerData as default };
